import { FC } from 'react'

interface AboutProps {}

const About: FC<AboutProps> = () => {
  return (
    <div
      className="bloc none bloc-bg-texture texture-darken-strong d-bloc bloc-fill-screen"
      id="about-section"
    >
      <div className="container">
        <div className="row">
          <div className="offset-lg-1 col-lg-10">
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h1 className="mg-md text-lg-center h1-about-style text-white">
                  About Us
                </h1>
              </div>
            </div>
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h2 className="mg-md text-lg-center h3-about-style text-white fix-header">
                  We specialize in the architecture and development of web
                  applications.
                </h2>
              </div>
            </div>
            <p className="text-lg-center p-7-style scroll-fx-up-in mt-md-4 mt-sm-2">
              Universal Applications Consulting is an IT consulting firm
              established in Montreal, Canada since 2018. We specialize in the
              development of web applications and provide consulting services in
              the areas of software development, software architecture, and
              software engineering. Leading the firm is an IT engineer with a passion
              for technology and innovation. We are always looking for new
              challenges and new ways to improve our skills.
            </p>
          </div>
        </div>
        <div
          className="row none animated zoomIn"
          data-appear-anim-style="zoomIn"
        >
          <div className="col bgc-black devider-left">
            <h1 className="mg-md h1-style text-lg-left text-white">
              &#47;&#47;&nbsp;EXTENSIBILITY&nbsp;&#47;&#47;
            </h1>
            <p className="p-1-style">
              We understand that your business needs may change over time. We
              are committed to providing you with solutions that can be easily
              extended to meet your future needs without having to start from
              scratch or changing your existing solution.
            </p>
            <h1 className="mg-md h1-style text-lg-left text-white">
              &#47;&#47;&nbsp;TESTABILITY&nbsp;&#47;&#47;
            </h1>
            <p className="p-2-style">
              We are aware that testing is an important part of the software
              engineering and that the solutions we provide are built to be
              easily and efficiently tested. This will help you to identify and
              fix bugs early on in the development process.
            </p>
          </div>
          <div className="col devider-left">
            <h1 className="mg-md h1-style text-lg-left text-white">
              &#47;&#47;&nbsp;MANAGEABILITY&nbsp;&#47;&#47;
            </h1>
            <p className="p-about-style">
              Manageability is an important supplement to the traditional
              elements of reliability, availability, and serviceability. UAC
              incorporates manageability features into your web applications
              which provides a number of benefits.
            </p>
            <h1 className="mg-md h1-style text-lg-left text-white">
              &#47;&#47;&nbsp;MODULARITY&nbsp;&#47;&#47;&nbsp;
            </h1>
            <p className="p-4-style">
              A system we design is built from well-defined building blocks.
              These building blocks are modular units that can be used to build
              a system. This makes it easy to add new features to a module in
              your system without having to change other modules.
            </p>
          </div>
          <div className="col devider-left devedier-right">
            <h1 className="mg-md h1-style text-lg-left text-white">
              &#47;&#47;&nbsp;SCALABILITY&nbsp;&#47;&#47;
            </h1>
            <p className="p-5-style">
              We are aware that your web development requirements may change
              with circumstances. That is why we create scalable solutions that
              can be adjusted to suit your needs at different times. This is why
              we are among the best.
            </p>
            <h1 className="mg-md h1-style text-lg-left text-white">
              &#47;&#47;&nbsp;AFFORDABILITY&nbsp;&#47;&#47;
            </h1>
            <p className="p-6-style">
              We value the relationship we have with our clients. Our web
              development services are available at competitive rates to make
              sure it doesn&rsquo;t become a burden to your budget.
              Cost-effectiveness makes our solutions ideal for all.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
